import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const contactClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 15000,
  withCredentials: false,
});

export async function submitContactForm(formData) {
  const response = await contactClient.post('/contact.php', {
    name: formData.name.trim(),
    email: formData.email.trim(),
    phone: formData.phone?.trim() || null,
    subject: formData.subject.trim(),
    message: formData.message.trim(),
    website: formData.website || '',
  });

  return response.data;
}
